// extracted by mini-css-extract-plugin
module.exports = {"accordion":"__accordion__5eUjM","faqContainer":"__faqContainer__gaw5g"};